import React from 'react';
import { Card } from '../../../common/Card';

export const ActivityLoadingState: React.FC = () => {
  return (
    <div>
      <div className="flex items-center mb-3">
        <div className="h-6 w-24 bg-muted animate-pulse rounded" />
      </div>

      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="p-4 border-foreground/15">
            <div className="flex items-start">
              <div className="mr-4">
                <div className="h-8 w-8 bg-muted animate-pulse rounded-full" />
              </div>
              <div className="flex-1">
                <div className="flex justify-between items-start">
                  <div className="h-5 w-32 bg-muted animate-pulse rounded" />
                  <div className="h-4 w-24 bg-muted animate-pulse rounded" />
                </div>
                <div className="h-4 w-full bg-muted animate-pulse rounded mt-2" />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
